export { MainTestimonials } from './MainTestimonials';
